__turbopack_context__.v({
  "container": "q_5A9G_container",
  "grid": "q_5A9G_grid",
  "grid-carousel": "q_5A9G_grid-carousel",
  "scroll-area": "q_5A9G_scroll-area",
});
